/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-anchor {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.qds-breadcrumb-item {
  align-items: center;
  display: inline-flex;
  font: var(--qds-control-standard-text);
  gap: var(--qds-control-standard-gap-siblings-related);
  height: var(--qds-control-standard-height);
  width: inherit;
}

.qds-divider {
  margin-inline: auto;
}

.qds-overflow {
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qds-anchor,
.qds-breadcrumb-item {
  color: var(--qds-theme-control-text-standard);

  &:focus-visible {
    outline: var(--qds-focus-border-width) solid var(--qds-theme-focus-border);
    outline-offset: var(--qds-focus-border-offset);
    border-radius: var(--qds-focus-border-radius);
  }
}
